webClient.controller('AirBookingResponseWarning', ['$scope', '$window', '$timeout', '$i18next', 'tseApiClient', 'tseUtil', 'tseAirResultsHelper', function ($scope, $window, $timeout, tseApiClient, tseUtil, airHelper, bookingRequest, insurancesSelected, $i18next) {
 
}]);